import React from "react";
import PhoneFrame from "./phoneFrame";
import styled from "styled-components";
import canvasVideo from "videos/spotifyCanvas.mp4";

import leftImg from "images/png/canvasimg1.png";
import rightImg from "images/png/canvasimg2.png";
import { Colors } from "utils/colors";

const SpotifyCanvasTool = () => {
  return (
    <Container>
      {/* <BgContainer /> */}
      <PhoneFrame
        width="14.6rem"
        height="31.8rem"
        image={leftImg}
        mHeight="20rem"
        mWidth="9.3rem"
      />
      <PhoneFrame
        width="19.3rem"
        height="42rem"
        video={canvasVideo}
        center
        mHeight="26.8rem"
        mWidth="12.3rem"
      />
      <PhoneFrame
        width="14.6rem"
        height="31.8rem"
        image={rightImg}
        mHeight="20rem"
        mWidth="9.3rem"
      />
    </Container>
  );
};

export default SpotifyCanvasTool;

const Container = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  padding-top: 6rem;
  gap: 2rem;
  position: relative;
  @media only screen and (max-width: 769px) {
    margin-bottom: 2rem;
  }
`;

const BgContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 40rem;
  height: 40rem;
  opacity: 0.2;
  border-radius: 50%;
  background-color: ${Colors.primary};
`;
